import { FC } from "react";

import {
  ProductSwitcher as DSProductSwitcher,
  ProductId,
  SpacingToken,
  useProductSwitcher,
} from "@livechat/design-system-react-components";

import Block from "components/layout/Block";
import { config } from "config/config";
import { EventPlace, trackEngagement } from "helpers/analytics";
import { withVar } from "themes/helpers";

import { useProductData } from "./use-product-data";

const parseEnv = (env: string): "labs" | "staging" | "prod" => {
  switch (env) {
    case "production":
      return "prod";
    case "staging":
      return "staging";
    case "labs":
    default:
      return "labs";
  }
};

export const ProductSwitcher: FC = () => {
  const { organizationId, installedProducts, subscriptions } = useProductData();

  const parsedEnv = parseEnv(config.env);

  if (!organizationId) {
    return null;
  }

  const { products } = useProductSwitcher({
    env: parsedEnv,
    installedProducts,
    organizationId,
    subscriptions,
    mainProductId: "helpdesk",
  });

  const textUrlWithUtm = `${config.textHomePage}?utm_source=app.helpdesk.com&utm_medium=referral&utm_campaign=productswitcher`;

  const handleOpen = (): void => {
    trackEngagement("Product switcher: opened", EventPlace.Navbar);
  };

  const handleClose = (): void => {
    trackEngagement("Product switcher: closed", EventPlace.Navbar);
  };

  const handleSelect = (id: ProductId): void => {
    trackEngagement("Product switcher: product switched", EventPlace.Navbar, { productId: id });
  };

  return (
    <Block marginBottom={withVar(SpacingToken.Spacing3)} data-testid="product-switcher">
      <DSProductSwitcher
        mainProductId="helpdesk"
        productOptions={products}
        onSelect={handleSelect}
        onOpen={handleOpen}
        onClose={handleClose}
        textURL={textUrlWithUtm}
      />
    </Block>
  );
};
